import React, {Fragment} from 'react';
import blockStyles from '@baseStyles/block.scss';
import ContentB1 from "@components/blocks/ContentB1/ContentB1";
import ContentB4 from "@components/blocks/ContentB4/ContentB4";
import Button from "@components/base/Button/Button";
import useDataFileAction from "@hooks/useDataFileAction";

const ContentA1 = ({data, color = ''}) => {

	if (!data) {
		return null;
	}

	const {executeAction, ModalPortal} = useDataFileAction({color: color});

	const blockTitle = data.blockTitle;
	const blockDesc = data.blockDesc;
	const contentLeft = data.blockContent.left;
	const contentRight = data.blockContent.right;

	return (
	  <>
		  <div className={blockStyles.baseContainerHolder}>
			  {/* INTRO CONTAINER */}
			  {/*///////////////////////////////////////////////////////////////////////////////*/}
			  <ContentB1 title={blockTitle} desc={blockDesc}/>

			  <div className={`${blockStyles.baseContainer} ${color ? blockStyles[color] : ''}`}>
				  <div className={blockStyles.columnContainer}>

					  {/* LEFT COLUMN CONTENT */}
					  {/*///////////////////////////////////////////////////////////////////////////////*/}
					  <div className={`${blockStyles.textBox} ${contentLeft.gap ? blockStyles[contentLeft.gap] : ''}`}>
						  {contentLeft.content && contentLeft.content.map((item, key) => {
							  return (
								<Fragment key={key}>
									{/* Title */}
									{item.title &&
									  <h2
										className={blockStyles.h3}
										dangerouslySetInnerHTML={{__html: item.title}}
									  />
									}

									{/* Text */}
									{item.text &&
									  <div
										className={blockStyles.p}
										dangerouslySetInnerHTML={{__html: item.text}}>
									  </div>
									}

									{/* Button */}
									{item.buttonText &&
									  <Button
										value={item.buttonText}
										onClick={() => executeAction(item)}
									  />
									}
								</Fragment>
							  );
						  })}
					  </div>

					  {/* RIGHT COLUMN CONTENT */}
					  {/*///////////////////////////////////////////////////////////////////////////////*/}
					  <div
						className={`${blockStyles.textBox} ${contentRight.gap ? blockStyles[contentRight.gap] : ''}`}>
						  {contentRight.content && contentRight.content.map((item, key) => {
							  return (
								<div key={key}>
									{/* Title */}
									{item.title &&
									  <h3
										className={blockStyles.h4}
										dangerouslySetInnerHTML={{__html: item.title}}
									  />
									}

									{/* Subtitle */}
									{item.subtitle &&
									  <div
										className={`${blockStyles.p} ${blockStyles['color-gray-500']}`}
										dangerouslySetInnerHTML={{__html: item.subtitle}}>
									  </div>
									}

									{/* Description */}
									{item.description &&
									  <div
										className={blockStyles.p}
										dangerouslySetInnerHTML={{__html: item.description}}>
									  </div>
									}

									{/* Button */}
									{item.buttonText &&
									  <Button
										value={item.buttonText}
										onClick={() => executeAction(item)}
									  />
									}
								</div>
							  );
						  })}
					  </div>
					  {/*///////////////////////////////////////////////////////////////////////////////*/}

				  </div>
			  </div>

			  {/* Render modal with portal (in html.php container - <div id="modalContainer"></div>) */}
			  {/*///////////////////////////////////////////////////////////////////////////////*/}
			  {ModalPortal}
			  {/*///////////////////////////////////////////////////////////////////////////////*/}
		  </div>

		  {data.blockContent.noteData && data.blockContent.noteData.length > 0 &&
			<div className={blockStyles.baseContainerHolder}>
				<ContentB4 data={data.blockContent.noteData} color={color}/>
			</div>
		  }
	  </>
	)
}

export default ContentA1;
